import { getTerritoryNameByOrderId } from '../../../../utils/map/MapMarkersUtils';

export function createPlanPopup(data, translations, orders) {
  const {
    id,
    address,
    highPriority,
    labels,
    isPickup,
    isPudo,
    isEditing,
    territory,
    skills,
    priority,
    group,
    pudoDuration,
    pudoAssignAt,
    parkingId,
    availableParkings,
  } = data;
  //
  const {
    global: { pudoLabel, assignParkingLabel, noneParkingLabel },
    locationPopup: { pudoDurationLabel, pudoAssignAtFirst, pudoAssignAtLast } = {},
    map: {
      typeJobDeliveryMarkerTrans,
      typeJobPickupMarkerTrans,
      territoryMarkerTrans,
      skillsMarkerTrans,
      groupMarkerTrans,
      priorityTrans,
    },
    wizard: {
      orders: { editedOrderPriorityHigh },
    },
  } = translations;

  const addressLabel = address ? `${address}<br/>` : '';
  const priorityLabel = highPriority
    ? `<div style="background-color: #FFD500; color: #000; font-weight: bold; margin-bottom: 0.5rem; text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${editedOrderPriorityHigh}</div>`
    : '';
  const titleTooltip = [address, ...(labels || [])].filter(Boolean).join(' - ');
  const title = labels
    ? `<div class="plan-popup-title" title="${titleTooltip.replace(/"/g, '&quot;')}" style="color: #000; font-weight: bold; margin-bottom: 0.5rem; word-break: break-word; overflow-wrap: break-word;">${priorityLabel}${addressLabel}${labels.join(
        '<br />',
      )}</div>`
    : '';

  const typeString = isPudo
    ? pudoLabel
    : isPickup
    ? typeJobPickupMarkerTrans
    : typeJobDeliveryMarkerTrans;

  const groupName =
    Array.isArray(group) && group.filter(Boolean).length > 0
      ? `<div>${groupMarkerTrans}: ${group.filter(Boolean).join(', ')}</div>`
      : '';

  const territoryFull = getTerritoryNameByOrderId(orders, id);
  const territoryName =
    territoryFull && territory?.type !== 'group'
      ? `<div>${territoryMarkerTrans}: ${territoryFull}</div>`
      : '';

  const skillsArr = skills ? `<div>${skillsMarkerTrans}: ${skills}</div>` : '';

  const priorityFull = priority ? `<div>${priorityTrans}: ${priority}</div>` : '';

  const pudoDurationStr =
    isPudo && pudoDuration != null ? `<div>${pudoDurationLabel}: ${pudoDuration}</div>` : '';
  const assignAtLabel = pudoAssignAt === 'last' ? pudoAssignAtLast : pudoAssignAtFirst;
  const pudoAssignAtStr = isPudo && pudoAssignAt != null ? `<div>${assignAtLabel}</div>` : '';

  const escapeAttr = (val) => (val ?? '').toString().replace(/"/g, '&quot;');
  const selectedParkingText = parkingId || noneParkingLabel || '';
  const selectedParkingTitle = escapeAttr(selectedParkingText);
  const parkingSelect =
    !isPudo && !isEditing && Array.isArray(availableParkings) && availableParkings.length > 0
      ? `<div class="parking-assignment">
          <label>${assignParkingLabel}:</label>
          <select class="parking-assignment-select" data-order-id="${id}" title="${selectedParkingTitle}">
            <option value=""${!parkingId ? ' selected' : ''} title="${escapeAttr(noneParkingLabel)}">${noneParkingLabel}</option>
            ${availableParkings
              .map(
                (p) =>
                  `<option value="${p.id}"${p.id === parkingId ? ' selected' : ''} title="${escapeAttr(p.id)}">${
                    p.id
                  }</option>`,
              )
              .join('')}
          </select>
        </div>`
      : '';

  return `${title}${typeString}${
    territoryName || ''
  }${groupName}${skillsArr}${priorityFull}${pudoDurationStr}${pudoAssignAtStr}${parkingSelect}`;
}
